import { render } from "./VendorView.vue?vue&type=template&id=0dc702cc&scoped=true"
import script from "./VendorView.vue?vue&type=script&lang=js"
export * from "./VendorView.vue?vue&type=script&lang=js"

import "./VendorView.vue?vue&type=style&index=0&id=0dc702cc&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc702cc"]])

export default __exports__